"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RoomStatusDisplayPageActions;
(function (RoomStatusDisplayPageActions) {
    RoomStatusDisplayPageActions["Loading"] = "Loading";
    RoomStatusDisplayPageActions["Loaded"] = "Loaded";
})(RoomStatusDisplayPageActions || (RoomStatusDisplayPageActions = {}));
exports.default = RoomStatusDisplayPageActions;
